import LegalPageShell from "../components/legal/LegalPageShell";
import { CURRENT_TERMS_VERSION } from "../lib/legalConsent";

const sectionClassName = "space-y-3";
const headingClassName = "text-base font-bold text-[#5D4D46]";
const listClassName = "list-decimal space-y-2 pl-5";

export default function TermsPage() {
  return (
    <LegalPageShell>
      <h1 className="text-2xl font-bold text-[#5D4D46]">WizMate 利用規約</h1>

      <p>
        株式会社ウィズダムネットワークス（以下「当社」といいます。）が提供する「WizMate」（以下「本サービス」といいます。）の利用にあたっては、本利用規約（以下「本規約」といいます。）への同意が必要です。
      </p>
      <p>
        ユーザーは、本規約および当社のプライバシーポリシーの内容を確認し、当社所定の方法で同意したうえで、本サービスを利用するものとします。
      </p>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第1条（適用）</h2>
        <ol className={listClassName}>
          <li>本規約は、本サービスの利用に関する当社とユーザーとの間の一切の関係に適用されます。</li>
          <li>当社が本サービス上で掲載するプライバシーポリシー、料金ページ、申込画面、ガイドライン、注意事項その他の個別規定は、本規約の一部を構成します。</li>
          <li>本規約と個別規定の内容が異なる場合は、個別規定に特段の定めがない限り、個別規定が優先して適用されます。</li>
        </ol>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第2条（定義）</h2>
        <p>本規約において、次の用語はそれぞれ以下の意味を有します。</p>
        <ol className={listClassName}>
          <li>「ユーザー」とは、本規約に同意し、事業または業務に関連して本サービスを利用する個人をいいます。</li>
          <li>「登録ユーザー」とは、当社所定の方法により利用登録を完了したユーザーをいいます。</li>
          <li>「入力データ」とは、ユーザーが本サービスに入力、送信、アップロード、連携その他の方法で提供する情報をいいます。</li>
          <li>「AI出力」とは、ユーザーの入力その他の情報に基づき、本サービス上でAIにより生成、整理または加工される文章、要約、提案、回答、音声、レポート、調査結果その他の出力をいいます。</li>
          <li>「顧客データ」とは、入力データ、AI出力、プロファイル、利用設定、利用履歴その他、本サービスの提供・運用に伴い当社が取り扱うユーザーに関する情報をいいます。</li>
          <li>「外部サービス」とは、AI、検索、情報提供、資料・画像・音声の処理、通知、決済、認証、クラウド保存、監視その他、本サービスの提供に関連して利用される第三者のサービスまたは情報源をいいます。</li>
          <li>「有料プラン」とは、当社が有料で提供するプランをいいます。</li>
          <li>「特典コード」とは、当社がキャンペーン、紹介その他の目的で発行する、一定期間または一定範囲で利用条件を拡張するためのコードをいいます。</li>
          <li>「退会」とは、本サービスのアカウントを終了することをいいます。有料プランのみを終了する「解約」とは異なります。</li>
        </ol>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第3条（利用登録および規約への同意）</h2>
        <ol className={listClassName}>
          <li>本サービスは、18歳以上の方を対象とします。</li>
          <li>ユーザーは、当社所定の登録画面におけるチェックボックスその他の明示的な方法により、本規約およびプライバシーポリシーに同意したうえで、利用登録を行うものとします。</li>
          <li>当社は、ユーザーが同意した規約およびプライバシーポリシーのバージョン、同意日時その他必要な情報を記録することがあります。</li>
          <li>
            当社は、次の各号のいずれかに該当する場合、利用登録を拒否し、または登録後に取り消すことがあります。
            <ol className="mt-2 list-decimal space-y-2 pl-5">
              <li>本規約に同意しない場合</li>
              <li>過去に本規約違反等により利用停止等を受けたことがある場合</li>
              <li>反社会的勢力に該当し、または関与していると当社が判断した場合</li>
              <li>本サービスの利用目的が不適切であると当社が判断した場合</li>
              <li>その他、当社が利用登録を適当でないと合理的に判断した場合</li>
            </ol>
          </li>
        </ol>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第4条（アカウント管理）</h2>
        <ol className={listClassName}>
          <li>ユーザーは、自己の責任でアカウント情報、認証情報および外部サービス連携情報を管理するものとします。</li>
          <li>ユーザーは、アカウントまたは認証情報を第三者に利用させ、貸与し、譲渡し、または売買してはなりません。</li>
          <li>ユーザーは、認証情報の漏えい、不正利用その他の異常を知った場合、速やかに当社へ連絡するものとします。</li>
          <li>アカウントの管理不十分、使用上の過誤または第三者利用により生じた損害について、当社は、当社の責めに帰すべき場合を除き責任を負いません。</li>
        </ol>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第5条（本サービスの内容）</h2>
        <ol className={listClassName}>
          <li>本サービスは、事業または業務に関連する各種支援を提供するAIサービスです。</li>
          <li>本サービスの内容、機能、仕様、対応環境、利用可能回数、対象プランおよび制限事項は、当社が本サービス上で別途表示する内容に従います。</li>
          <li>本サービス上のAIキャラクターまたは専門家役は、実在する人物または資格者ではなく、AIによる応答・役割表現です。</li>
          <li>本サービスは、ユーザーの判断および業務を補助するものであり、ユーザーに代わって最終的な判断または意思決定を行うものではありません。</li>
          <li>当社は、本サービスの改善、法令対応、外部サービスの変更その他の事情により、本サービスの全部または一部を変更、追加または廃止することがあります。</li>
        </ol>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第6条（外部サービス）</h2>
        <ol className={listClassName}>
          <li>本サービスは、機能提供のため、AI、検索、情報提供、資料・画像・音声の処理、通知、決済、認証、クラウド保存、監視その他の外部サービスを利用します。</li>
          <li>ユーザーが本サービスの各機能を利用する際、入力内容またはアップロードした資料等のうち、当該機能の処理に必要な情報が外部サービスで処理または保存される場合があります。</li>
          <li>処理または保存の対象となる情報とその範囲は、利用する機能に応じて必要最小限に留めます。生成AI等による処理では、文書については原則として原本ではなく抽出した本文等を利用し、画像や音声の内容を読み取る機能では、画像または音声の内容を処理する場合があります。</li>
          <li>前2項の処理または保存により、当該情報が一般に公開され、または他のユーザーへ共有されるものではありません。</li>
          <li>外部サービスの利用には、当該外部サービスの利用規約、プライバシーポリシー、利用制限その他の条件が適用される場合があります。</li>
          <li>当社は、機能、品質、安全性、提供条件等を考慮し、利用する外部サービスまたはモデルを変更することがあります。</li>
          <li>顧客データの取扱いの詳細は、プライバシーポリシーに定めます。</li>
          <li>外部サービスの仕様変更、停止、不具合、利用制限、情報源の変更その他の事情により、本サービスの全部または一部が利用できず、遅延し、または出力内容が変化する場合があります。</li>
        </ol>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第7条（プラン、料金、支払および有料プランの解約）</h2>
        <ol className={listClassName}>
          <li>本サービスには、無料プラン、有料プラン、特典コードによる利用その他当社が定める利用形態があります。</li>
          <li>プランごとの料金、利用可能機能、利用回数、利用上限、配信頻度その他の条件は、料金ページ、申込画面または管理画面に表示する内容に従います。</li>
          <li>ユーザーが有料プランを申し込む場合、申込画面に表示された料金および条件に同意し、当社所定の方法で利用料金を支払うものとします。</li>
          <li>決済は、当社が指定する決済代行事業者を通じて行われます。</li>
          <li>ユーザーが本人以外の名義による支払手段を利用する場合、当該支払手段を利用する正当な権限を有するものとします。</li>
          <li>月額の有料プランは、ユーザーが解約手続きを完了しない限り、申込時に表示された請求サイクルに従って自動更新されます。</li>
          <li>当社が有料プランの料金を変更する場合、変更内容および適用開始時期を事前に通知または表示します。変更後の料金は、当該適用開始日以後に更新される契約から適用します。</li>
          <li>ユーザーは、管理画面、決済代行事業者の管理画面その他当社所定の方法により、有料プランを解約できます。</li>
          <li>有料プランを解約した場合、次回更新日以降の請求は停止されます。解約後も、既に支払済みの利用期間中は、当該プランを利用できます。</li>
          <li>法令上必要な場合または当社が別途認める場合を除き、日割り計算または既に支払われた料金の返金は行いません。</li>
          <li>利用上限の未使用分は、当社が別途明示する場合を除き、翌月その他の期間へ繰り越されません。</li>
          <li>「実質無制限」その他これに類する表示がある場合でも、短時間の大量実行、過度な高負荷利用、通常の利用目的を逸脱する利用その他本サービスの運営に支障を及ぼす利用について、当社は合理的な範囲で利用を制限することがあります。</li>
          <li>有料プランの解約は、アカウントの退会または顧客データの削除を意味しません。</li>
        </ol>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第8条（入力データ）</h2>
        <ol className={listClassName}>
          <li>入力データに関する権利は、ユーザーまたは正当な権利者に留保されます。</li>
          <li>ユーザーは、入力データについて、本サービスへ提供するために必要な権利、権限および同意を有するものとします。</li>
          <li>ユーザーは、第三者の個人情報、機密情報、営業秘密、著作物その他の情報を入力する場合、自らの責任で必要な権限および同意を確認するものとします。</li>
          <li>当社は、入力データを、本サービスの提供、運用、保守、セキュリティ対応、品質改善その他プライバシーポリシーに定める目的のため、必要な範囲で取り扱います。これには、本サービスの提供に必要な範囲で外部サービスに処理させることを含みます。</li>
          <li>当社は、ユーザーの明示的な同意がない限り、入力データをWizMate独自モデルの学習、再学習またはfine-tuningに利用せず、外部AI事業者の汎用モデル学習へ任意提供しません。</li>
          <li>前項は、本サービスを提供するためのAI処理、不正利用監視、安全性確認、法令・契約に基づく一定期間の保持または品質確認を禁止するものではありません。</li>
        </ol>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第9条（AI出力の権利および利用）</h2>
        <ol className={listClassName}>
          <li>ユーザーは、法令、本規約および第三者の権利に反しない範囲で、AI出力を自らの事業その他の目的に利用し、編集、加工、複製、公表または第三者へ提供できます。</li>
          <li>当社は、AI出力について当社に帰属する譲渡可能な権利がある場合、当該権利を、法令上可能な範囲で当該AI出力を生成したユーザーに譲渡します。</li>
          <li>AI出力に著作権その他の権利が成立すること、AI出力が独自であること、ユーザーが排他的な権利を取得すること、または第三者の権利を侵害しないことは保証されません。</li>
          <li>AIの性質上、同一または類似のAI出力が他のユーザーその他の第三者に生成または提供される場合があります。</li>
          <li>ユーザーは、AI出力を公開、商用利用または重要な意思決定に利用する前に、正確性、適法性、第三者の権利その他必要な事項を自ら確認するものとします。</li>
          <li>本条は、本サービスのプログラム、画面、デザイン、商標、システムプロンプト、テンプレートその他本サービス自体に関する権利をユーザーへ移転するものではありません。</li>
        </ol>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第10条（顧客データの利用および品質改善）</h2>
        <ol className={listClassName}>
          <li>当社は、顧客データを、本サービスの提供、運用、改善その他プライバシーポリシーに定める目的で利用します。</li>
          <li>問い合わせ、障害調査、品質確認その他前項の目的に必要な場合、権限を有する担当者が顧客データの内容を確認することがあります。</li>
          <li>当社は、個別の顧客、法人、利用者または案件を識別できない形に集計した情報を、サービス改善、利用傾向の分析、ランキング、推薦その他の目的で利用できます。</li>
          <li>当社は、個別顧客の原文または個別顧客を識別できる情報を、当該顧客の同意なく他の顧客へ表示または共有しません。</li>
        </ol>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第11条（保存、連携解除、退会および削除）</h2>
        <ol className={listClassName}>
          <li>当社は、顧客データを、本サービスの提供、再表示、再利用、運用、改善、法令・セキュリティ対応その他の目的に必要な期間保存します。</li>
          <li>ユーザーは、問い合わせ窓口への連絡その他当社所定の方法により、外部サービスとの連携解除または退会を申し出ることができます。</li>
          <li>外部サービスとの連携を解除した場合、当社は、当社が保有する連携用認証情報を削除または無効化します。ただし、連携先の外部サービス上に既に作成または保存されたデータは、当該連携解除のみでは削除されない場合があります。</li>
          <li>ユーザーが退会した場合、当社は、当該アカウントによる本サービスの利用を停止し、会話、資料、AI出力その他の利用者コンテンツを、当社所定の期間内に、機能提供および再利用の対象から削除または無効化します。</li>
          <li>
            前項にかかわらず、当社は、次の情報を、それぞれの目的に必要な期間保持する場合があります。
            <ol className="mt-2 list-decimal space-y-2 pl-5">
              <li>契約、課金、決済および返金に関する記録</li>
              <li>本規約、プライバシーポリシーその他への同意記録</li>
              <li>セキュリティ、不正利用、監査、障害、問い合わせおよび削除処理に関する記録</li>
              <li>法令上または当社もしくは第三者の権利保護上必要な記録</li>
              <li>個別の顧客を識別できない集計情報</li>
            </ol>
          </li>
          <li>バックアップ、処理中のキュー、ログ、監視サービスまたは外部サービスの仕組みにより、顧客データの一部が直ちに完全消去されない場合があります。この場合、当社は、当該データを通常の機能提供または再利用の対象とせず、保存目的に必要な範囲で管理します。</li>
          <li>有料プランの解約のみでは、アカウントは退会となりません。</li>
        </ol>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第12条（禁止事項）</h2>
        <p>ユーザーは、本サービスの利用にあたり、次の行為をしてはなりません。</p>
        <ol className={listClassName}>
          <li>法令または公序良俗に違反する行為</li>
          <li>犯罪行為またはこれを助長する行為</li>
          <li>当社、他のユーザーまたは第三者の権利または利益を侵害する行為</li>
          <li>第三者の個人情報、機密情報、営業秘密、著作物その他の情報を、必要な権限なく入力または利用する行為</li>
          <li>虚偽、不正確または誤解を招く情報を、第三者を欺く目的で入力、生成または利用する行為</li>
          <li>本サービスまたはAI出力を、差別、誹謗中傷、詐欺、迷惑行為、危険行為その他不適切な目的で利用する行為</li>
          <li>不正アクセス、攻撃、脆弱性の悪用、過度な負荷、スクレイピング、リバースエンジニアリングその他本サービスの運営または安全性を害する行為</li>
          <li>利用上限、認証、料金、技術的制限または安全機能を回避する行為</li>
          <li>アカウント、認証情報または本サービスへのアクセス権を第三者へ販売、貸与または共有する行為</li>
          <li>当社の事前の書面による承諾なく、本サービスの画面、機能、APIまたは出力生成能力を、第三者向けのサービスとして再提供、再販売、OEM提供その他これらと同様の形で利用する行為</li>
          <li>当社の事前の書面による承諾なく、AI出力をほぼ無加工のまま大量に生成・収集し、その販売または再配信自体を主な目的とする行為</li>
          <li>本サービスのモデル、プロンプト、データ、機能または出力を利用して、本サービスと実質的に競合する汎用的なAIサービスを構築または提供する行為</li>
          <li>外部サービスの利用規約または利用制限に違反する行為</li>
          <li>反社会的勢力への利益供与その他反社会的勢力に関与する行為</li>
          <li>その他、当社が本サービスの目的に照らして不適切であると合理的に判断する行為</li>
        </ol>
        <p>前項第10号から第12号までの規定は、第9条に従ってAI出力をユーザー自身の事業で利用し、または通常の成果物の一部として第三者へ提供することを禁止するものではありません。</p>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第13条（本サービスに関する知的財産権）</h2>
        <ol className={listClassName}>
          <li>本サービスのプログラム、システム、デザイン、商標、文章、画像、テンプレート、プロンプト、データベース、ノウハウその他本サービス自体に関する知的財産権は、当社または正当な権利者に帰属します。</li>
          <li>ユーザーは、本規約に基づき本サービスを利用する権利を有するにとどまり、前項の知的財産権を取得するものではありません。</li>
          <li>入力データおよびAI出力の権利については、第8条および第9条に従います。</li>
          <li>ユーザーが当社へ任意に提供した意見、要望または改善提案について、当社は、個人情報または機密情報を含まない範囲で、本サービスの改善・開発に利用できます。</li>
        </ol>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第14条（本サービスの変更、停止、中断および終了）</h2>
        <ol className={listClassName}>
          <li>
            当社は、次の各号のいずれかに該当する場合、本サービスの全部または一部を停止または中断することがあります。
            <ol className="mt-2 list-decimal space-y-2 pl-5">
              <li>システムの保守、点検、更新を行う場合</li>
              <li>障害、事故、通信回線、クラウドサービスまたは外部サービスの不具合が発生した場合</li>
              <li>天災地変、停電、戦争、暴動、感染症、法令改正、行政指導その他の不可抗力が発生した場合</li>
              <li>セキュリティ上の理由により必要な場合</li>
              <li>その他、当社が停止または中断を合理的に必要と判断した場合</li>
            </ol>
          </li>
          <li>当社は、本サービスの全部または重要な一部を恒久的に終了する場合、合理的な予告期間を設け、本サービス上または当社Webサイトへの表示その他当社が適切と判断する方法で通知します。ただし、緊急の場合または予告が困難な場合はこの限りではありません。</li>
          <li>本サービスの終了時における有料プランの取扱いは、法令に従い、当社が別途通知します。</li>
        </ol>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第15条（利用停止および登録抹消）</h2>
        <ol className={listClassName}>
          <li>
            当社は、ユーザーが次の各号のいずれかに該当する場合、事前の通知または催告なく、本サービスの利用制限、利用停止、アカウント停止、登録抹消その他必要な措置を講じることがあります。
            <ol className="mt-2 list-decimal space-y-2 pl-5">
              <li>本規約に違反した場合</li>
              <li>支払遅延または決済不能が発生した場合</li>
              <li>本サービスの運営、安全性または他のユーザーに重大な影響を与えるおそれがある場合</li>
              <li>その他、当社が本サービスの利用継続を不適当と合理的に判断した場合</li>
            </ol>
          </li>
          <li>前項の措置により登録が抹消された場合の顧客データの取扱いには、第11条を準用します。</li>
          <li>ユーザーは、利用停止または登録抹消後も、当該措置以前に発生した料金の支払義務その他の義務を免れません。</li>
        </ol>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第16条（AI出力等に関する保証の否認）</h2>
        <ol className={listClassName}>
          <li>AI出力は、ユーザーの判断を補助するものであり、当社は、その正確性、完全性、最新性、有用性、適法性、独自性、非侵害、特定目的への適合性その他の事項を保証しません。</li>
          <li>AI出力には、事実と異なる情報、古い情報、推測、不完全な情報、不適切な表現または第三者の権利に関わる内容が含まれる場合があります。</li>
          <li>ニュース、レポート、企業情報、検索結果その他の情報は、公開情報、外部情報源、AI処理等に基づき生成される場合があり、当社は、その正確性、網羅性または継続提供を保証しません。</li>
          <li>法律、税務、会計、労務、医療、金融、投資、許認可その他専門的判断を要する事項について、AI出力は専門家の助言に代わるものではありません。ユーザーは、必要に応じて資格を有する専門家または一次情報を確認するものとします。</li>
          <li>ユーザーは、AI出力その他本サービス上の情報を自己の責任で確認、判断および利用するものとします。</li>
          <li>当社は、本サービスがユーザーの特定目的に適合すること、期待する成果が得られること、継続的または中断なく利用できること、不具合がないことを保証しません。</li>
        </ol>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第17条（損害賠償および責任制限）</h2>
        <ol className={listClassName}>
          <li>当社の故意または重大な過失によりユーザーに損害が生じた場合、当社は法令に従って責任を負います。</li>
          <li>当社の故意または重大な過失による場合を除き、当社がユーザーに対して損害賠償責任を負う場合、その責任は、ユーザーに現実に発生した通常かつ直接の損害に限られ、その上限は、損害発生時点から過去1か月間にユーザーが当社に支払った利用料金の総額とします。ただし、当該期間に利用料金の支払がないユーザーについては、1,000円を上限とします。</li>
          <li>当社は、当社の故意または重大な過失による場合を除き、特別損害、間接損害、逸失利益、事業機会の喪失、データ消失または信用毀損について責任を負いません。</li>
          <li>前2項の責任制限は、消費者契約法その他の法令により無効または適用が制限される範囲には適用されません。</li>
          <li>ユーザーが本規約に違反し、または入力データもしくはAI出力の利用により第三者との間で紛争を生じさせ、当社に損害を与えた場合、ユーザーは、自己の責任と費用で当該紛争を解決し、当社に生じた通常かつ直接の損害を賠償するものとします。ただし、当社の責めに帰すべき事由による場合を除きます。</li>
        </ol>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第18条（規約の変更）</h2>
        <ol className={listClassName}>
          <li>当社は、法令に従い、本規約を変更することがあります。</li>
          <li>当社は、本規約を変更する場合、変更内容および効力発生日を、本サービス上または当社Webサイトへの表示その他当社が適切と判断する方法で周知します。</li>
          <li>ユーザーに重要な影響を及ぼす変更については、必要に応じて改めて同意を求めることがあります。</li>
          <li>ユーザーが変更後の本規約に同意しない場合、ユーザーは本サービスの利用を終了し、退会を申し出ることができます。</li>
        </ol>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第19条（通知、権利義務の譲渡および分離可能性）</h2>
        <ol className={listClassName}>
          <li>当社からユーザーへの通知は、本サービス上または当社Webサイトへの表示その他当社が適切と判断する方法で行います。</li>
          <li>ユーザーは、当社の事前の書面による承諾なく、本規約上の地位または本規約に基づく権利義務を第三者へ譲渡、移転、担保設定その他処分できません。</li>
          <li>当社は、本サービスに関する事業を第三者へ譲渡し、または承継させる場合、本規約上の地位、権利義務および顧客データを、法令に従って当該第三者へ承継させることがあります。</li>
          <li>本規約の一部が法令または裁判所により無効または執行不能と判断された場合でも、その他の部分は継続して有効に存続します。</li>
        </ol>
      </section>

      <section className={sectionClassName}>
        <h2 className={headingClassName}>第20条（準拠法、管轄および問い合わせ）</h2>
        <ol className={listClassName}>
          <li>本規約の準拠法は日本法とします。</li>
          <li>本サービスに関して当社とユーザーとの間で紛争が生じた場合、当社所在地を管轄する地方裁判所または簡易裁判所を、第一審の専属的合意管轄裁判所とします。ただし、法令により別の管轄が認められる場合を除きます。</li>
          <li>
            本規約に関する問い合わせ先は、次のとおりです。
            <p className="mt-2">
              株式会社ウィズダムネットワークス
              <br />
              <a href="mailto:wizmate@wisdomnetworks.co.jp" className="underline underline-offset-4">
                wizmate@wisdomnetworks.co.jp
              </a>
            </p>
          </li>
        </ol>
      </section>

      <div className="border-t border-[#EADBC8] pt-6">
        <p>制定日：2026年6月29日</p>
        <p>改定日：2026年8月5日</p>
        <p>規約バージョン：{CURRENT_TERMS_VERSION}</p>
      </div>
    </LegalPageShell>
  );
}
